<template>
  <div class="goods_list_container">   
	 <!-- 筛选区域 -->
    <div class="goods_list clearfix">
		<div class="all_result_tip flex_row_start_center"><span ><router-link  to="/member/coupon">
			我的优惠券</router-link></span><div class="all" >> 使用范围</div></div>
		<div class="couponInfo flex_row_start_center">
		
			<div class="price_limit ">
				<div  class="flex_row_start_end" v-if='couponInfo.data.couponType!=2'>
					<div class="sign">￥</div>
					<div class='publishValue'>{{couponInfo.data.publishValue}}</div>
				</div>
				<div class="flex_row_start_end" v-else>
					<div class="publishValue">{{couponInfo.data.publishValue}}</div>
					<div class="zhe">折</div>
				</div>
				<div class="limit">订单满{{couponInfo.data.limitQuota}}可用</div>				
			</div>
			<div class="ci_sep"></div>
			<div class="ci_name_time">
				<div class="name_deal">
					<div class="coupon_name">{{couponInfo.data.couponName}}</div>
					<div class="deal_btn" :class="{disable:formCoupon}" @click='onAccept()'>{{formCoupon?'已领取':'领取' }}</div>
				</div>
				
				<div class="coupon_des">{{couponInfo.data.description}}</div>
				<div class="coupon_time">有效期：{{getDataYMD(couponInfo.data.effectiveStart)}}～{{getDataYMD(couponInfo.data.effectiveEnd)}}</div>
			</div>
			<div class="ci_app flex_row_start_end">
				<div class="explain ">
					<div>手机扫码下载APP</div>	
					<div>立即使用优惠券</div>
				</div>
				<div class="app_qcode_container flex_row_center_center">
					<img class="app_qcode"  src="@/assets/goods/code_app.png">
				</div>
					
			</div>
		</div>
		<div class="sort_info flex_row_start_center">			
			<div class="sort_txt" :class="{sel:sortType==0}" @click="onSortTap(0)">综合推荐</div>
			<div class="sort_sep"></div>
			<div class="sort_item price flex_row_start_center" @click="onPriceSortTap" >
				<div class="sort_txt " :class="{sel:sortType==3||sortType==4}">价格</div>
				<img class="sort_icon " v-if='sortType==3' src="@/assets/goods/icon_price_up_sel.png"/>
				<img class="sort_icon " v-else-if='sortType==4'  src="@/assets/goods/icon_price_down_sel.png"/>
				<img class="sort_icon " v-else  src="@/assets/goods/icon_price_up.png"/>
			</div>
			<div class="sort_sep"></div>
			<div class="sort_txt" :class="{sel:sortType==1}" @click="onSortTap(1)">销量优先</div>
		</div>      
    </div>
	
    <!-- 商品列表 -->
	<div class="goods_container">
		<div class="goods_item" @click="toGoodsDetail(goodsIndex,goodsItem.productId)" v-for="(goodsItem,goodsIndex) in goodsData.data" :key="goodsIndex">
			<img class="goods-img" :src="goodsItem.mainImageUrl"/>
			<div class="goods-name">				
				<img  class="new_product_img" v-if="goodsItem.newProdcut" src="@/assets/goods/icon_newproduct.png"/>
				<div class="new_product_name">{{goodsItem.productShortTitle}}</div>
			</div>
			<div class="goods-short" v-if="goodsItem.specValues">{{goodsItem.specValues}}</div>
			<div class="promotion flex_row_start_center" v-if='goodsItem.hasAct||goodsItem.actShowList&&goodsItem.actShowList.length>0'>
				<div class="act_item act"  v-if='goodsItem.firstOrder'>
					{{ goodsItem.showFirstName}}
				</div>
				
				<div class="act_item" v-else-if='goodsItem.isFlashSale'>
					{{ goodsItem.showName}}
				</div>
				<div  class="act_item act"  v-else-if='goodsItem.hasAct'>
					{{ goodsItem.showName}}
				</div>			
				
				<div  class="act_item"  v-for="(item,index) in goodsItem.actShowList" :key='index'>
					{{item}}
				</div>
			</div>
			<div class="goods-price flex_row_center_center">
				<template v-if='goodsItem.hasAct'>
					<div class="productPrice" :class="{wait:goodsItem.promotionType==107&&!goodsItem.activityPrice}" >
						{{goodsItem.promotionType==107&&!goodsItem.activityPrice?'待发布':'¥'+goodsItem.activityPrice.toFixed(2)}}
					</div>
					<div class="origlnalPrice" v-if='!(goodsItem.promotionType==107&&!goodsItem.activityPrice)'>
						¥{{goodsItem.productPrice.toFixed(2)}}
					</div>	
				</template>
				
				<div class="productPrice " v-else>
					¥{{goodsItem.productPrice.toFixed(2)}}
				
				</div>
			</div>
			
		</div>
	</div>	
	<SldCommonEmpty v-show="isEmpty" />

    <!-- 分页 -->
    <div class="flex_row_center_center sld_pagination">
      <el-pagination @current-change="handleCurrentChange" v-model:currentPage="goodsData.page.current" :page-size="goodsData.page.pageSize"
        layout="prev, pager, next, jumper" :total="goodsData.page.total" :hide-on-single-page="true">
      </el-pagination>
    </div>

    <SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" />
    



  
  </div>
</template>
<script>
import {
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  watch
} from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SldLoginModal from '../../components/loginModal'
import SldCommonEmpty from '../../components/SldCommonEmpty'

export default {
  name: 'goodsList',
  components: {
    SldLoginModal,
    SldCommonEmpty,		
  },
  setup () {
    const firstLoading = ref(true) //是否第一次加载

    const store = useStore()
    const loginModalVisibleFlag = ref(false) //登录弹框是否显示，默认不显示
    
    const route = useRoute()
    const router = useRouter()
	const current=ref(1)
	const sortType=ref(0)
	const couponInfo=reactive({data:{}})
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const goodsData = reactive({ data: [], page: {} })  //商品列表
    
    const isEmpty = ref(false)   
    const scrollTop = ref(null)
    const formCoupon=ref(false)

    //方法------------------------------
    //初始化数据，进行请求-start
    const getInitData = (notNeedToTop) => {
			if(!notNeedToTop){
				window.scrollTo(0, scrollTop.value)
			}
      
       let searchParams = {
				"couponId": couponInfo.data.couponId,
				"current": current.value,
				"pageSize": 25,
				"sort":sortType.value
	   	}
       proxy.$post('v3/goods/front/goods/couponProductList', searchParams, 'json').then(res => {
        
        firstLoading.value = false
		
		 //just for test
         //res=getProductListTest()
		
		
        if (res.state == 200) {
          goodsData.data = res.data.list.map(item => {
            if(item.activityList){
					var tmpList=[]
					var actList=[]
					var zplist=[];
					var mxList=[];
					var yhqlist=[]
					
					item.activityList.forEach((aItem)=>{
						if(aItem.promotionType==403){ //赠品
							zplist.push('赠品');
						
						}else if(aItem.promotionType==405){
							mxList=mxList.concat(aItem.descriptionList)
							
						}else if(aItem.promotionType==402){
							yhqlist=yhqlist.concat(aItem.descriptionList)
						
						}
						
						else if(aItem.promotionType==103){
							// aItem.promotionName='预售'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.promotionType=aItem.promotionType;
							item.showName='预售';
							// actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==106){
							// aItem.promotionName='抢购'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.isFlashSale=true
							item.promotionType=aItem.promotionType;
							item.showName='限时';
							//actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==107){
							// aItem.promotionName='预约'
							// aItem.hasAct=1;
							item.hasAct=1;
							item.promotionType=aItem.promotionType;	
							item.showName='预约';									
							//actList.push(aItem)
							
						
						}
						else if(aItem.promotionType==501){
							item.hasAct=1;
							item.firstOrder=1; 
							item.promotionType=aItem.promotionType;	
							item.showFirstName='首单';	
						}
						else if(aItem.promotionType==408){	//新品  									
							item.newProdcut=1; 
							item.promotionType=aItem.promotionType;	
							
						}
					})								
												
					tmpList=zplist.concat(mxList)
					tmpList=tmpList.concat(yhqlist)								
					item.actShowList=tmpList.length>3?tmpList.slice(0,3):tmpList;								
				}else {
					item.actShowList=[]
				}
		
            return item
          })


          isEmpty.value = res.data.list.length ? false : true
          goodsData.page= res.data.pagination
          
         
        }else{
          ElMessage(res.msg)
		  goodsData.page={}
		  goodsData.data=[]
		  
        }
      })
    }

	const getDataYMD=(dataStr)=>{		
		if(dataStr){
			let arr = dataStr.trim().split(" ");
			return arr[0].replace(/-/g, '.');
		}else{
			return ''
		}
	}
	
	// 排序 0:默认排序；1销量；2评论；3价格从低到高；4、价格从高到低；5、人气从高到低；6、收藏数从高到低；7、店铺推荐
	const onSortTap=(type)=>{
		if(sortType.value==type){
			return
		}
		 scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		sortType.value=type
		getInitData()
	}

	const onPriceSortTap=()=>{
		 scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
		if(sortType.value!=3&&sortType.value!=4){
			sortType.value=3;
		}else{
			sortType.value=sortType.value==3?4:3
		}
		getInitData()
	}

	const onAccept=()=>{
		if(formCoupon.value){
			return
		}
		if (!store.state.loginFlag) {				
			goToByPush("/login", {});
			return
		}
        receive(couponInfo.data.couponId)
			
	}


	//领取优惠卷
	const receive = couponId => {
			proxy
				.$get('v3/promotion/front/coupon/receiveCoupon', { couponId })
				.then(res => {
					if (res.state == 200) {
						ElMessage.success(L['领取成功'])
						getCouponList()
					} else {
						ElMessage(res.msg)
					}
				})
				.catch(() => {
					//异常处理
				})
	}
   
    //初始化数据，进行请求-end
    const toGoodsDetail=(index,productId)=>{

			let newWin = router.resolve({
				path: `/goods/detail`,
				query: {productId:productId}
			})
			window.open(newWin.href, '_blank')

     // window.open(`/goods/detail?productId=${productId}`, '_blank');
      // router.push({
      //     path: `/goods/detail`,
      //     query: { productId: productId}
      //   });
      
    }
   
	

    
    //页数改变的方法-start
    const handlePrevCilickChange = e => {
      current.value = e
      getInitData()
    }
    const handleNextCilickChange = e => {
		current.value = e
		getInitData()
    }
    const handleCurrentChange = e => {
		current.value = e
		getInitData()
    }
    //页数改变的方法-end
	
	

   
    //关闭登录弹框
    const closeLoingModal = () => {
      loginModalVisibleFlag.value = false
    }
    
    
	const getDetailData = (notNeedToTop) => {			
      let searchParams = {
			"couponIds": [couponInfo.data.couponId],
	   	}
      proxy.$post('v3/promotion/front/coupon/diyHomeCouponList', searchParams, 'json').then(res => {
        
        if (res.state == 200 && res.data && res.data.length > 0) {
          couponInfo.data = res.data[0]
        }else{
		  if(res.state == 200){
			//ElMessage("获取失败")
		  }else{
			ElMessage(res.msg)
		  }
          
        }
      })
    }


	const selItemFoucse=(type,selItem,selIndex)=>{
		selItem.isFocus=type;
	}
	

    onMounted(() => {
		if(route.query.couponInfo){
			 couponInfo.data = JSON.parse(route.query.couponInfo)
		}else if(route.query.couponId){
			couponInfo.data ={
				couponId:route.query.couponId
			}
		}
       
		let from=route.query.from;
		// 如果不是来自优惠列表
		if(!from||from&&from!='coupon'){			
			getDetailData()
			formCoupon.value=false;
		}else{
			formCoupon.value=true;
		}
        getInitData()
	  	document.addEventListener('visibilitychange', handleVisibilityChange);
		if (!store.state.loginFlag) {				
			goToByPush("/login", {});
			return
		}
			
    })

	onBeforeUnmount(()=>{	
		document.removeEventListener('visibilitychange', handleVisibilityChange);
	})

	const goTop = () =>{
		window.scrollTo({
			top: 0, // 滚动到页面顶部
			behavior: 'smooth' // 平滑滚动（可选）
		});
	}

	const handleVisibilityChange=()=>{
      if (document.visibilityState === 'visible') {
        console.log('窗口变为了可见状态');
		if(!formCoupon.value){
			getDetailData()
		}
		getInitData()
       
      } else if (document.visibilityState === 'hidden') {
        console.log('窗口变为了隐藏状态');
        
      }
    }


    const goToByPush =(type,param = {})  => {
			router.push({
        path: type,
        query: param
      });
	}

	const getProductListTest=()=>{
		return {
			"data": {
				"pagination": {
					"current": 1,
					"total": 110,
					"pageSize": 20
				},
				"list": [
					{
						"productShortTitle": "星空经典蓝色",
						"marketPrice": null,
						"isBooking": null,
						"goodsId": 100002030004,
						"goodsSubtitle": "无线4K有线8K回报",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "咨询客服享好礼！官方补贴见右角标！",
						"activityList": [
							// {
							// 	"promotionGrade": null,
							// 	"promotionName": "首单专享活动",
							// 	"promotionType": 501,
							// 	"descriptionList": null,
							// 	"startTime": null,
							// 	"goodsPromotionId": null,
							// 	"memberCategories": null,
							// 	"promotionId": null,
							// 	"platforms": null
							// },
							{
								"promotionGrade": null,
								"promotionName": "新品",
								"promotionType": 408,
								"descriptionList": null,
								"startTime": null,
								"goodsPromotionId": null,
								"memberCategories": null,
								"promotionId": null,
								"platforms": null
							},
							{
								"promotionGrade": 103,
								"promotionName": "预售活动",
								"promotionType": 107,
								"descriptionList": null,
								"startTime": "2024-10-31 10:00:59",
								"goodsPromotionId": 700,
								"memberCategories": "[36,17,1,0]",
								"promotionId": 53,
								"platforms": null
							},
							{
								"promotionGrade": null,
								"promotionName": null,
								"promotionType": 403,
								"descriptionList": null,
								"startTime": null,
								"goodsPromotionId": null,
								"memberCategories": null,
								"promotionId": null,
								"platforms": null
							},
							{
							"promotionGrade": 1,
							"promotionName": "免息",
							"promotionType": 405,
							"descriptionList": ["花呗6期免息"],
							"startTime": "2024-10-31 10:00:59",
							"goodsPromotionId": 700,
							"memberCategories": "[36,17,1,0]",
							"promotionId": 53,
							"platforms": null
						}],
						"goodsName": "ROG月刃2 ACE 三模游戏鼠标 AimPoint Pro光学传感器 月耀白",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/2eXwPq6lpSKTJGz3VpX.jpg?bindId=283?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002090005,
						"specValues": "默认",
						"writeImageUrl": null,
						"defaultProductId": 200002090005,
						"storeId": 460003,
						"saleNum": 111,
						"categoryId1": 286450,
						"categoryId2": 286461,
						"commentsNumber": 0,
						"categoryId3": 286509,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 199.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 8499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": 300,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [{
							"promotionGrade": 1,
							"promotionName": "加价购活动",
							"promotionType": 406,
							"descriptionList": null,
							"startTime": "2024-11-02 00:00:00",
							"goodsPromotionId": 735,
							"memberCategories": "[1,17,36,0]",
							"promotionId": 57,
							"platforms": null
						}],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590003,
						"specValues": "i9-13900H 16G 1TB 2.5K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590003,
						"storeId": 460003,
						"saleNum": 3,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 7499.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 6799.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590002,
						"specValues": "i9-13900H 32G 1TB 2.5K ",
						"writeImageUrl": null,
						"defaultProductId": 200001590002,
						"storeId": 460003,
						"saleNum": 2,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6199.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 7499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": 100,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [{
							"promotionGrade": 1,
							"promotionName": "加价购活动",
							"promotionType": 406,
							"descriptionList": null,
							"startTime": "2024-11-20 00:00:00",
							"goodsPromotionId": 857,
							"memberCategories": "[1,17,36,0]",
							"promotionId": 69,
							"platforms": null
						}, 
						{
							"promotionGrade": null,
							"promotionName": null,
							"promotionType": 402,
							"descriptionList": ["满5000元打7.3折"],
							"startTime": null,
							"goodsPromotionId": null,
							"memberCategories": null,
							"promotionId": null,
							"platforms": null
						}],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590004,
						"specValues": "Ultra7 32G 1TB 2.8K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590004,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6999.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 7499.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590005,
						"specValues": "Ultra7 32G 1TB 2.8K 夜空蓝 ",
						"writeImageUrl": null,
						"defaultProductId": 200001590005,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 6999.0
					},
					{
						"productShortTitle": "短标题",
						"marketPrice": 6799.0,
						"isBooking": null,
						"goodsId": 100001540002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "SSD大固态 2.5K屏 预装正版永久Office",
						"activityList": [],
						"goodsName": "华硕破晓4 14英寸2.5K AI高性能轻薄商务办公笔记本",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/eLYWZmspD3Xo5uqvIKF.jpg?bindId=64?x-oss-process=image/resize,w_300,h_300",
						"productId": 200001590006,
						"specValues": "Ultra9 32G 1TB 2.8K 冰川银",
						"writeImageUrl": null,
						"defaultProductId": 200001590006,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5899.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-07",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190008,
						"specValues": "魔幻青 |512GB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190008,
						"storeId": 460003,
						"saleNum": 5,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 9999999.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-08",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190009,
						"specValues": "魔幻青 |512GB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190009,
						"storeId": 460003,
						"saleNum": 2,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 16523.51
					},
					{
						"productShortTitle": "165Hz 高色域",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002020005,
						"goodsSubtitle": "锐龙版 16英寸电竞",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "AI PC为游戏和创作赋能！100W PD快充，快速补能！加购全面保享晒单再返30！",
						"activityList": [],
						"goodsName": "华硕枪神 Pro 锐龙版 16英寸电竞游戏本 笔记本电脑 ",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/tqbhfuyquI7X2e63zSX.png?bindId=247?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002080006,
						"specValues": "R9-7940HX,魔幻青",
						"writeImageUrl": null,
						"defaultProductId": 200002080006,
						"storeId": 460003,
						"saleNum": 11,
						"categoryId1": 286450,
						"categoryId2": 286462,
						"commentsNumber": 0,
						"categoryId3": 286507,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 8279.0
					},
					{
						"productShortTitle": "wmw短标题20241129001-06",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190007,
						"specValues": "日蚀灰 |1TB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190007,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 1568.95
					},
					{
						"productShortTitle": "wmw短标题20241129001-09",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190010,
						"specValues": "魔幻青 |512GB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190010,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 4989466.46
					},
					{
						"productShortTitle": "wmw短标题20241129001-12",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190013,
						"specValues": "魔幻青 |1TB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190013,
						"storeId": 460003,
						"saleNum": 1,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 45613.47
					},
					{
						"productShortTitle": "wmw短标题20241129001-01一共可以填写30字呢",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190002,
						"specValues": "日蚀灰 |512GB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190002,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5321.1
					},
					{
						"productShortTitle": "改下改下wmw短标题20241129001-02",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190003,
						"specValues": "日蚀灰 |512GB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190003,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 48650.15
					},
					{
						"productShortTitle": "wmw短标题20241129001-03",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190004,
						"specValues": "日蚀灰 |512GB |【TUF电竞特工白】TUF-RTX4070TIS-O16G-WHIT",
						"writeImageUrl": null,
						"defaultProductId": 200002190004,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 132.17
					},
					{
						"productShortTitle": "wmw短标题20241129001-04",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190005,
						"specValues": "日蚀灰 |1TB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190005,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 155318.51
					},
					{
						"productShortTitle": "wmw短标题20241129001-05",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/Mqjd1NzpUCOsgamLSzr.jpg?bindId=284?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190006,
						"specValues": "日蚀灰 |1TB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190006,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 5623.16
					},
					{
						"productShortTitle": "wmw短标题20241129001-10",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190011,
						"specValues": "魔幻青 |1TB |【吹雪S D5】ROG Z890-A WIFI ",
						"writeImageUrl": null,
						"defaultProductId": 200002190011,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 652156.85
					},
					{
						"productShortTitle": "wmw短标题20241129001-11",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002120002,
						"goodsSubtitle": null,
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "wmw商品简介20241129001能有50个字呢是检测报告安随非常是正常访问去一个苦苦衣服SCPI",
						"activityList": [],
						"goodsName": "wmw商品名称20241129001",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/axaP3qxFDxkEaPCowJj.jpg?bindId=272?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002190012,
						"specValues": "魔幻青 |1TB |【热销】夜魔 月曜白 NX雪武白轴 ",
						"writeImageUrl": null,
						"defaultProductId": 200002190012,
						"storeId": 460003,
						"saleNum": 0,
						"categoryId1": 286449,
						"categoryId2": 286458,
						"commentsNumber": 0,
						"categoryId3": 286465,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 13506.84
					},
					{
						"productShortTitle": "165Hz 高色域",
						"marketPrice": 0.0,
						"isBooking": null,
						"goodsId": 100002020005,
						"goodsSubtitle": "锐龙版 16英寸电竞",
						"isFollowGoods": false,
						"activityPrice": null,
						"isOwnShop": null,
						"storeName": "ROG商城",
						"goodsBrief": "AI PC为游戏和创作赋能！100W PD快充，快速补能！加购全面保享晒单再返30！",
						"activityList": [],
						"goodsName": "华硕枪神 Pro 锐龙版 16英寸电竞游戏本 笔记本电脑 ",
						"mainImageUrl": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/tqbhfuyquI7X2e63zSX.png?bindId=247?x-oss-process=image/resize,w_300,h_300",
						"productId": 200002080007,
						"specValues": "R9-7940HX,日蚀灰",
						"writeImageUrl": null,
						"defaultProductId": 200002080007,
						"storeId": 460003,
						"saleNum": 5,
						"categoryId1": 286450,
						"categoryId2": 286462,
						"commentsNumber": 0,
						"categoryId3": 286507,
						"storeCategoryId": [],
						"rankId": null,
						"goodsRank": null,
						"productPrice": 8479.0
					}
				]
			},
			"msg": "成功",
			"state": 200,
			"timestamp": 1740104237962
		}
	}

 
    //返回值
    return {
      goodsData,
	  current,
	  sortType,
	  couponInfo,
	  onSortTap,
	  onPriceSortTap,
	  getDataYMD, 
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goToByPush,
      L,
      isEmpty,
      firstLoading,     
      loginModalVisibleFlag,
      closeLoingModal,      
      toGoodsDetail,
	   goTop,
	   formCoupon,
	   onAccept
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/couponGoodsList.scss";
@import "../../style/base.scss";

.empty_page {
  flex-direction: column;
  padding: 100px;
}

.sld_pagination {
  margin-top: 50px;
  margin-bottom: 95px;
}

/*添加css样式*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss" scoped>
.side_menu {
    position: fixed;
    top: calc(100vh - 676px);
    right: 30px;
    z-index: 999;

  }
</style>
